module.exports = __webpack_public_path__ + "img/font_4.ae7ab424.webp";